import "../assets/css/banners.css";
import { useEffect, useState } from "react";
import { Loading } from "../components/loading";
import { MediaSlider } from "../components/mediaSlider";

export const Banners = ({ banners, isShowSectionTitle = true }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (banners && banners.length > 0) {
      setLoading(false);
    }
  }, [banners, isShowSectionTitle]);

  return (
    <section id="banners">
      {loading ? (
        <Loading />
      ) : (
        <div className="banners-container">
          {isShowSectionTitle && (
            <div>
              <h3>BANNERS</h3>
              <hr />
            </div>
          )}
          <MediaSlider mediaList={banners} />
        </div>
      )}
    </section>
  );
};
